/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HistoricoRequisicaoAliases {
  FRAGMENT_ANEXO_TISS = 'fragment-anexoTiss',
  FRAGMENT_REQUISICAO_DATA = 'fragment-requisicaoData',
  PANEL_HISTORICO_REQUISICAO = 'panel-historico-requisicao',
  TAB_CONTROL_0 = 'tab-control-0',
  TAB_WITH_CONTENT_ANEXO_TISS = 'tab-with-content-anexoTiss',
  TAB_WITH_CONTENT_REQUISICAO_DATA = 'tab-with-content-requisicaoData',
}
export { HistoricoRequisicaoAliases };
